import { create } from "zustand";

type ConnectorHomeSidebarItem = {
  systemId: string;
  name: string;
  description?: string;
};

interface ConnectorHomeSidebarState {
  systems: ConnectorHomeSidebarItem[];
  setSystems: (systems: ConnectorHomeSidebarItem[]) => void;
  clearSystems: () => void;
}

export const useConnectorHomeSidebarStore = create<ConnectorHomeSidebarState>(
  (set) => ({
    systems: [],
    setSystems: (systems) => set({ systems }),
    clearSystems: () => set({ systems: [] }),
  }),
);
